import React from 'react'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  item?: AccountLinkModel
}

const AccountLinkTypeColumn: React.VFC<Props> = ({ item }) => {
  const { t } = useCustomTranslation()
  if (item) {
    return <Typography variant={'body2'}>{t(`common.accountType.${item.accountType}`)}</Typography>
  }
  return <Typography variant={'body2'}>-</Typography>
}

export default AccountLinkTypeColumn
